import { useMemo } from "react";
import { useCompany } from "../contexts/CompanyContext";
import { filterVisibleProjects } from "../utils/projectVisibility";

// Filtrera även cachade listor på varje flaggändring, utan att ändra originaldata.
export default function useVisibleProjects(projects) {
  const { customersAndProjectsEnabled, myCompanyEnabled } = useCompany();
  return useMemo(
    () => filterVisibleProjects(projects, customersAndProjectsEnabled, myCompanyEnabled),
    [projects, customersAndProjectsEnabled, myCompanyEnabled]
  );
}
